
export class AppRole {
  public static readonly BNDES_CHEFE: string = 'AnaliseFinanciamentoAprovacaoChefeDepartamentoAPA';
	public static readonly BNDES_ANALISTA: string = 'AnaliseFinanciamentoAPA';
	public static readonly BNDES_GERENTE: string = 'AnaliseFinanciamentoAprovacaoGerenteAPA';
	public static readonly BNDES_AUDITOR: string = 'PesquisaPACAuditoria';
	public static readonly AGENTE_FINANCEIRO: string = 'FinanciamentoAPA';
	public static readonly AGENTE_FINANCEIRO_PESQUISA: string = 'PesquisaFinanciamentoAPA';
	public static readonly AGENTE_FINANCEIRO_QUALQUER_PESQUISA: string = 'PesquisaFinanciamentoQualquerAgenteAPA';
	public static readonly BNDES_SOLICITACOES: string = 'PesquisaSolicitacoesAPA';
	public static readonly BNDES_SOLICITACOES_QUALQUER: string = 'PesquisaSolicitacoesQualquerAgenteAPA'
}
